<template>
    <tr @focusout="salvarItem()">
        <td class="table-status__error">
            <div>
                <v-tooltip top v-if="value.invalido">
                    <v-icon slot="activator" small color="red">error_outline</v-icon>
                    <div v-html="value.mensagem"></div>
                </v-tooltip>
            </div>
        </td>
        <td class="small-colunm">
          {{ descricaoLoteItem }}
        </td>
        <td class="small-colunm" v-if="value.ehModalidadeLeilao">
            <div>
                <v-icon
                    icon
                    small
                    class="mr-1 az-cursor-pointer"
                    @click.stop="abrirCarouselImagens(value, 0)"
                    title="Visualizar Imagens"
                >
                    photo_camera
                </v-icon>

                <span class="az-cursor-pointer" @click.stop="abrirCarouselImagens(value, 0)">
                    {{ value ? value.qtdImagens : 0 }}
                </span>
            </div>
        </td>
        <td class="small-colunm pt-1">
            <v-tooltip top max-width=750>
                  <span slot="activator">
                    <span class="circulo" v-if="value.tipoNegociacao === 'Exclusivo'"><span>E</span></span>
                    <span class="circulo" v-else-if="value.tipoNegociacao === 'Diferenciado'"><span>D</span></span>
                    <span class="circulo" v-else><span>S</span></span>
                  </span>
              <span v-if="value.tipoNegociacao === 'Exclusivo'">Exclusivo</span>
              <span v-else-if="value.tipoNegociacao === 'Diferenciado'">Diferenciado</span>
              <span v-else>Sem Diferenciação</span>
            </v-tooltip>
            <v-tooltip top max-width=750>
                <span slot="activator">
                  {{ value.itemCompraDescricao | az-clip-text(50) }}
                </span>
                <span>{{value.itemCompraDescricao}}</span>
            </v-tooltip>
        </td>
        <td class="small-colunm">
            <formatador-moeda :valor="value.quantidade" :casas-decimais="casasDecimaisQuantidade"></formatador-moeda>
        </td>
        <td class="input-small" v-if="!isMelhorTecnica" >
            <span v-if="value.ehModalidadeLeilao || esconderCamposProposta">
                {{getAtributoVisualizacao(value.marca)}}
            </span>
            <div v-else-if="value.tipo && value.tipo === 'SERVICO'">
                <v-tooltip top class="no-mobile">
                <span slot="activator">
                    <v-text-field v-model="value.marca" disabled class="text-field-disabled" prepend-inner-icon="info" />
                </span>
                    Para serviço os campos marca e modelo não serão preenchidos
                </v-tooltip>
            </div>
            <v-text-field v-else v-model="value.marca" maxlength="200" />
        </td>
        <td class="input-small" v-if="!isMelhorTecnica">
            <span v-if="value.ehModalidadeLeilao || esconderCamposProposta">
                {{getAtributoVisualizacao(value.modelo)}}
            </span>
            <div v-else-if="value.tipo && value.tipo === 'SERVICO'" >
                <v-tooltip top class="no-mobile">
                <span slot="activator">
                    <v-text-field v-model="value.modelo" disabled class="text-field-disabled" prepend-inner-icon="info" />
                </span>
                    Para serviço os campos marca e modelo não serão preenchidos
                </v-tooltip>
            </div>
            <v-text-field v-else v-model="value.modelo" maxlength="200" />
        </td>
        <td class="input-small" v-if="ehAmparoLei14133Art82 && !isMelhorTecnica">
          <span v-if="esconderCamposProposta">{{getAtributoVisualizacao(value.quantidadeProposta)}}</span>
          <v-text-field v-else v-validate="'required|integer|min_value:1|max_value:'+value.quantidade" v-model.number="value.quantidadeProposta" type="number"
                        :error-messages="errors.collect('Quantidade Proposta '+ value.licitacaoLoteItemId)"
                        :name="'Quantidade Proposta '+ value.licitacaoLoteItemId" max-length="8"
          ></v-text-field>
        </td>
        <td  class="small-colunm" style="text-align: right;" v-if="licitacao.mostrarValorReserva">
            <formatador-moeda :valor="value.valorUnitarioReferencia"
                              :casas-decimais="licitacao.casasDecimais"></formatador-moeda>
        </td>
        <td  class="small-colunm" style="text-align: right;" v-if="isMaiorDesconto">
              <formatador-moeda :valor="value.valorReferenciaDesconto" :casas-decimais="licitacao.casasDecimais"></formatador-moeda>
        </td>
        <td style="text-align: right;" class="input-small" v-if="!isMelhorTecnica">
            <span v-if="esconderCamposProposta">{{ precoVisualizacao }}</span>
            <campo-moeda v-model="value.preco" :casas-decimais="licitacao.casasDecimais" :id-campo="value.licitacaoLoteItemId" :menor-preco="false" v-else-if="!isMenorPreco"></campo-moeda>
            <az-money-licitacao
                v-else
                v-model="value.preco"
                prefix=""
                suffix=""
                :precision="licitacao.casasDecimais"
                placeholder="Informe"
                show-clear-button
                dense
                class="clear-button"
                event-submit="change"
                @input="atualizarValorInserido(value.preco)"
            ></az-money-licitacao>
        </td>
        <td style="text-align: center;" v-if="exibirPeriodicidade">
            <div class="periodicidade-proposta" v-if="itemEhPeriodico">
                <span class="badge-periodicidade-proposta">
                    <span>Periódico</span>
                    <small>{{ mesesPeriodicidade }} meses</small>
                </span>
                <v-tooltip top max-width="320" content-class="tooltip-periodicidade-proposta">
                    <v-icon slot="activator" class="periodicidade-proposta__icone">info_outline</v-icon>
                    <div>
                        <div class="tooltip-periodicidade-proposta__titulo">Periodicidade (informativo)</div>
                        <div>Período: {{ mesesPeriodicidade }} meses</div>
                        <div v-if="isMaiorDesconto">Percentual informado: {{ percentualPropostaFormatado }}%</div>
                        <div>Valor total do período: R$ {{ valorTotalPeriodoFormatado }}</div>
                        <div>Valor médio mensal: R$ {{ valorMedioMensalFormatado }}</div>
                        <div class="tooltip-periodicidade-proposta__divisor"></div>
                        <div class="tooltip-periodicidade-proposta__aviso">
                            Informação apenas para consulta.<br>
                            Não altera os valores da licitação.
                        </div>
                    </div>
                </v-tooltip>
            </div>
            <span v-else>–</span>
        </td>
        <td style="text-align: right;" v-if="isMaiorDesconto">
          <formatador-moeda :valor="valorTotalComDescontoPorItem" :casas-decimais="licitacao.casasDecimais"></formatador-moeda>
        </td>
        <td style="text-align: right;" v-if="isMenorPreco || isMaiorLance || isTecnicaPreco" class="small-colunm">
            <span v-if="esconderCamposProposta">{{valorTotalItemFormatado}}</span>
            <formatador-moeda :valor="valorTotalItem" :casas-decimais="2" v-else></formatador-moeda>
        </td>
        <td class="anexos" v-if="!isMelhorTecnica">
            <div v-if="(isLoteExclusivo && isFornecedorMicroEmpresa) || !isLoteExclusivo">
                <licitacao-fornecedor-proposta-item-anexo @eventoUpload="salvarItem()"
                                                          @eventoRemover="salvarItem()"
                                                          v-if="value.incluirFicha && podeEditarArquivos(value.fichaTecnica)"
                                                          v-model="value" tipo-anexo="fichaTecnica"/>
                <licitacao-fornecedor-proposta-item-anexo @eventoUpload="salvarItem()"
                                                          @eventoRemover="salvarItem()"
                                                          v-if="value.incluirCatalogo && podeEditarArquivos(value.catalogo)"
                                                          v-model="value" tipo-anexo="catalogo"/>
            </div>
            <div v-else style="text-align: center">-</div>
        </td>
        <td style="text-align: right;" v-if="this.moeda && this.moeda.existeMoedaSelecionada" class="small-column">
          {{ this.moeda.sigla }}
          <span v-if="esconderCamposProposta">{{ valorTotalItemConvertido }}</span>
          <formatador-moeda :valor="valorTotalItemConvertido" :casas-decimais="2" v-else></formatador-moeda>
        </td>
      <imagem-carousel-dialog
          ref="imagemCarouselDialog"
          :fetch-action="actionTypes.BUSCAR_IMAGENS_ITEM_BASE64"
          :use-cache="true"
      />
    </tr>
</template>

<script>
import {mapState} from 'vuex'
import accounting from 'accounting'
import FormatadorMoeda from '@/commons/components/FormatadorMoeda'
import CampoMoeda from '@/commons/components/CampoMoeda'
import AzMoneyLicitacao from '@/commons/components/AzMoneyLicitacao'
import LicitacaoFornecedorPropostaItemAnexo from './LicitacaoFornecedorPropostaItemAnexo'
import {actionTypes, tiposLicitacao} from '@/commons/constants'
import ImagemCarouselDialog from "@/commons/components/ImagemCarouselDialog.vue";
import {normalizarCasasDecimais} from "@/commons/utils/CasasDecimaisUtils";
import PeriodicidadeUtils from "@/commons/utils/PeriodicidadeUtils";

const LOTE_EXCLUSIVO = 'Exclusivo'

    export default {
        name: 'LicitacaoFornecedorPropostaItem',
        inject: ['$validator'],
        components: {ImagemCarouselDialog, AzMoneyLicitacao, CampoMoeda, FormatadorMoeda, LicitacaoFornecedorPropostaItemAnexo},
        props: {
            value: {
                type: Object,
                required: true
            },
            moeda: {
              type: Object,
              required: true
            },
            exibirPeriodicidade: {
              type: Boolean,
              default: false
            }
        },
        computed: {
            ...mapState(['licitacao', 'propostaResumo', 'termoAceiteProposta']),
            actionTypes() {
               return actionTypes
            },
            descricaoLoteItem() {
                return this.value.loteDescricao + '/' + this.value.itemCompraCodigo
            },
            casasDecimaisQuantidade() {
                return normalizarCasasDecimais(this.licitacao.casasDecimaisQuantidade)
            },
            isFornecedorMicroEmpresa() {
                return this.termoAceiteProposta && this.termoAceiteProposta.microEmpresa === 'S'
            },
            isPropostaEnviada() {
                return this.propostaResumo.enviada
            },
            isLoteExclusivo() {
                return this.value.tipoNegociacao === LOTE_EXCLUSIVO
            },
            isLoteSituacaoAgendada() {
                return this.value.loteSituacao === 'AGENDADA'
            },
            esconderCamposProposta() {
                return this.isPropostaEnviada || (this.isLoteExclusivo && !this.isFornecedorMicroEmpresa) || !this.isLoteSituacaoAgendada
            },
            precoVisualizacao() {
                if (this.value.preco != null) {
                    return accounting.formatNumber(accounting.unformat(this.value.preco, ','), this.licitacao.casasDecimais, '.', ',')
                }
                return '-'
            },
            tipoNegociacao() {
                return this.value.tipoNegociacao === LOTE_EXCLUSIVO ? 'Sim' : 'Não'
            },
            valorTotalItem() {
                const quantidade = this.ehAmparoLei14133Art82 ? this.value.quantidadeProposta : this.value.quantidade
                const preco = accounting.unformat(this.value.preco, ',')
                const valorTotal = preco * quantidade

                if (this.itemEhPeriodico) {
                    return valorTotal * Number(this.value.periodicidade)
                }

                return valorTotal
            },
            valorTotalItemFormatado() {
                const valorTotal = this.valorTotalItem
                return valorTotal >= 0 && this.value.preco != null ? accounting.formatNumber(valorTotal, 2, '.', ',') : '-'
            },
            valorTotalItemConvertido() {
              const lanceForn = this.valorTotalItem;
              const cotacaoVenda = this.moeda.cotacaoVenda;
              let valorMeuLanceCotacao;

              if (cotacaoVenda >= 1) {
                valorMeuLanceCotacao = (lanceForn / cotacaoVenda).toFixed(5);
              } else {
                valorMeuLanceCotacao = (lanceForn * (1 / cotacaoVenda)).toFixed(6);
              }

              return parseFloat(valorMeuLanceCotacao);
            },
            isMenorPreco() {
                return tiposLicitacao[this.licitacao.tipoLicitacao] === tiposLicitacao.MP
            },
            isMaiorLance() {
                return tiposLicitacao[this.licitacao.tipoLicitacao] === tiposLicitacao.ML
            },
            isMelhorTecnica() {
                return tiposLicitacao[this.licitacao.tipoLicitacao] === tiposLicitacao.MTC
            },
            isTecnicaPreco() {
                return tiposLicitacao[this.licitacao.tipoLicitacao] === tiposLicitacao.TP
            },
            isMaiorDesconto() {
              return tiposLicitacao[this.licitacao.tipoLicitacao] === tiposLicitacao.MD
            },
            ehAmparoLei14133Art82() {
                return this.licitacao.amparoLegal && this.licitacao.amparoLegal.lei === 'Lei 14.133/2021, Art. 82, IV'
            },
            valorTotalComDescontoPorItem() {
              if (!this.isMaiorDesconto) {
                return 0;
              }
              const valorTotal = this.value.valorTotal;
              const descontoPercent = accounting.unformat(this.value.preco, ',');
              if (isNaN(valorTotal) || isNaN(descontoPercent)) return 0;
              return valorTotal * (1 - descontoPercent / 100);
            },
            itemEhPeriodico() {
                return PeriodicidadeUtils.possuiPeriodicidade(this.value)
            },
            mesesPeriodicidade() {
                return PeriodicidadeUtils.mesesPeriodicidade(this.value)
            },
            valorTotalPeriodoFormatado() {
                return PeriodicidadeUtils.formatarMoeda(this.valorTotalPeriodo)
            },
            valorMedioMensalFormatado() {
                return PeriodicidadeUtils.formatarMoeda(
                    PeriodicidadeUtils.valorMedioMensal(this.valorTotalPeriodo, this.mesesPeriodicidade)
                )
            },
            valorTotalPeriodo() {
                return this.isMaiorDesconto ? this.valorTotalComDescontoPorItem : this.valorTotalItem
            },
            percentualPropostaFormatado() {
                if (!this.value.preco) {
                    return '0,00'
                }

                return accounting.formatNumber(
                    accounting.unformat(this.value.preco, ','),
                    this.licitacao.casasDecimais,
                    '.',
                    ','
                )
            }
        },
        methods: {
            getAtributoVisualizacao(atributo) {
                return atributo ? atributo : '-'
            },
            podeEditarArquivos(arquivo) {
                if (this.isPropostaEnviada && !arquivo) {
                    return false
                }
                return true
            },
            criarPayload (){
                const payload = {
                    'licitacaoLoteItemId' : this.value.licitacaoLoteItemId,
                    'preco' : (this.value.preco === null || (!this.isMenorPreco && this.value.preco.trim() === '')) ?
                        null : accounting.unformat(this.value.preco, ','),
                    'quantidade' : this.value.quantidade,
                    'quantidadeProposta' : this.value.quantidadeProposta,
                    'marca' : (this.value.marca === null || this.value.marca.trim() === '') ? null : this.value.marca,
                    'modelo' : this.value.modelo,
                    'loteId' : this.value.loteId,
                    'fichaTecnica' : this.value.fichaTecnica,
                    'catalogo' : this.value.catalogo,
                    'loteSituacao' : this.value.loteSituacao
                }

                return payload
            },
            validarFicha(){
                return this.value.incluirFicha ? this.value.fichaTecnica != null && !(!this.value.fichaTecnica.anexoUri) : true
            },
            validarCatalogo(){
                return this.value.incluirCatalogo ? this.value.catalogo != null && !(!this.value.catalogo.anexoUri) : true
            },
            validarPreco(payload){
                return payload.preco != null && payload.preco >= 0
            },
            validarMarca(payload){
                const isObrigatorio = this.isTipoMaterial(this.value.tipo)
                if (isObrigatorio) {
                    return payload.marca != null && payload.marca.trim() != ''
                } else {
                    return true
                }
            },
            isTipoMaterial(tipo){
                return tipo === null || tipo === 'MATERIAL'
            },
            async validarQtd(){
              if(!this.ehAmparoLei14133Art82){
                return true
              }
              return await this.$validator.validate('Quantidade Proposta '+ this.value.licitacaoLoteItemId);
            },
            async atualizarValorInserido(novoValor) {
                this.value.preco = novoValor
            },
            async salvarItem(){
                const payload = this.criarPayload()

                if (this.validarFicha() && this.validarCatalogo() && this.validarPreco(payload) && await this.validarQtd(payload) && this.validarMarca(payload)) {
                  this.$emit('atualizarItemProposta', {licitacaoId: this.licitacao.id, payload})
                }
                if (this.value.incluirFicha && this.value.incluirCatalogo) {
                    if (this.value.fichaTecnica === null && this.value.catalogo === null) {
                        if (payload.preco === null && (payload.marca === null || payload.marca.trim() === '')) {
                            this.$emit('atualizarItemProposta', {licitacaoId: this.licitacao.id, payload})
                        }
                    }
                } else if (this.value.incluirFicha) {
                    if (this.value.fichaTecnica === null) {
                        if (payload.preco === null && (payload.marca === null || payload.marca.trim() === '')) {
                            this.$emit('atualizarItemProposta', {licitacaoId: this.licitacao.id, payload})
                        }
                    }
                } else if (this.value.incluirCatalogo) {
                    if (this.value.catalogo === null) {
                        if (payload.preco === null && (payload.marca === null || payload.marca.trim() === '')) {
                            this.$emit('atualizarItemProposta', {licitacaoId: this.licitacao.id, payload})
                        }
                    }
                } else {
                    if (payload.preco === null && (payload.marca === null || payload.marca.trim() === '')) {
                        this.$emit('atualizarItemProposta', {licitacaoId: this.licitacao.id, payload})
                    }
                }
            },
            abrirCarouselImagens(item, indexInicial = 0) {
                const itemId = (item && item.licitacaoLoteItemId) || null

                this.$refs.imagemCarouselDialog.open({
                    itemId,
                    index: indexInicial
                })
            },
        }
    }
</script>

<style lang="stylus">
    .input-small
        padding 0px 10px !important
        .v-text-field
            margin 0 !important
            padding-top 0 !important
        input
            max-height 20px
            font-size 13px
            color #777 !important

    .clear-button
        .v-input__icon
            min-width 13px
            width 13px
        i
            font-size 13px

    .small-colunm
        padding 0px 10px !important

    .circulo
      width 1.8em
      height 1.8em
      border-radius 50%
      background-color #bbb
      display inline-flex
      justify-content center
      align-items center
      font-size 12px
      font-weight bold
      color white


    .circulo span
      text-align center
      line-height 20px


    .az-cursor-pointer
        cursor pointer

    .text-field-disabled
        background-color #e5e5e5

    .text-field-disabled:hover
        cursor not-allowed

    .badge-periodicidade-proposta
        color #0072bc
        cursor default
        display flex
        flex-direction column
        font-size 11px
        font-weight 600
        line-height 14px

        small
            color #555
            font-size 10px
            font-weight normal
            line-height 12px

    .periodicidade-proposta
        align-items center
        display flex
        justify-content center

        &__icone
            color #1687d4 !important
            cursor default
            font-size 16px
            margin-left 4px

    .tooltip-periodicidade-proposta
        background-color #ffffff !important
        border 1px solid #e0e0e0
        border-radius 3px
        box-shadow 0 3px 10px rgba(0, 0, 0, .25)
        color #1f1f1f !important
        font-size 12px
        line-height 1.8
        opacity 1 !important
        padding 14px 16px !important

        &__titulo
            color #0067b1
            font-weight 600
            margin-bottom 6px

        &__divisor
            border-top 1px solid #dddddd
            margin 10px 0

        &__aviso
            color #757575
            font-size 11px
            line-height 1.5

</style>
